export const questionTemplates = [
  {
    value: 'What section is [name] in and what are their scores?',
    label: 'Find a Student',
    placeholders: ['name'],
    dataTestId: 'search_sections_bet_find_student',
  },
  {
    value: 'What is the overall assignment completion rate for each section?',
    label: 'Assignment Completion Rates',
    placeholders: [],
    dataTestId: 'search_sections_bet_assignment_completion',
  },
  {
    value:
      'Which of my sections have an overall course average below [percentage]%?',
    label: 'Course Average by Section',
    placeholders: ['percentage'],
    dataTestId: 'search_sections_bet_section_average',
  },
  {
    value:
      'For each of my sections, how many students have a course total below [percentage]%?',
    label: 'Students with Course Total below X%',
    placeholders: ['percentage'],
    dataTestId: 'search_sections_bet_total_below',
  },
  {
    value:
      'For each of my sections, how many students have a course total above [percentage]%?',
    label: 'Students with Course Total above X%',
    placeholders: ['percentage'],
    dataTestId: 'search_sections_bet_total_above',
  },
  {
    value:
      'Which sections have an assignment average below [percentage]% for [assignment name]?',
    label: 'Assignment Average below X%',
    placeholders: ['assignment name', 'percentage'],
    dataTestId: 'search_sections_bet_assign_avg_below',
  },
  {
    value:
      'Which sections have an assignment average above [percentage]% for [assignment name]?',
    label: 'Assignment Average above X%',
    placeholders: ['assignment name', 'percentage'],
    dataTestId: 'search_sections_bet_assign_avg_above',
  },
];
